
import {
  PieceImageType,
  BoardImageType,
} from "@/components/primitive/BoardLayout";
import { AppSettingUpdate } from "@/settings/app";
import { Action, Mutation, useStore } from "@/store";
import { ref, defineComponent, onMounted, Ref, computed } from "vue";
import { readInputAsNumber } from "@/helpers/form";
import { showModalDialog } from "@/helpers/dialog";

const returnCodeToName: { [name: string]: string } = {
  "\r\n": "crlf",
  "\n": "lf",
  "\r": "cr",
};

const nameToReturnCode: { [name: string]: string } = {
  crlf: "\r\n",
  lf: "\n",
  cr: "\r",
};

export default defineComponent({
  name: "AppSettingDialog",
  setup() {
    const store = useStore();
    const dialog: Ref = ref(null);
    const pieceImage: Ref = ref(null);
    const boardImage: Ref = ref(null);
    const pieceVolume: Ref = ref(null);
    const clockVolume: Ref = ref(null);
    const clockPitch: Ref = ref(null);
    const clockSoundTarget: Ref = ref(null);
    const returnCode: Ref = ref(null);

    onMounted(() => {
      showModalDialog(dialog.value);
    });

    const saveAndClose = async () => {
      const update: AppSettingUpdate = {
        pieceImage: pieceImage.value.value,
        boardImage: boardImage.value.value,
        pieceVolume: readInputAsNumber(pieceVolume.value),
        clockVolume: readInputAsNumber(clockVolume.value),
        clockPitch: readInputAsNumber(clockPitch.value),
        clockSoundTarget: clockSoundTarget.value.value,
        returnCode: nameToReturnCode[returnCode.value.value],
      };
      store.commit(Mutation.RETAIN_BUSSY_STATE);
      try {
        await store.dispatch(Action.UPDATE_APP_SETTING, update);
        store.commit(Mutation.CLOSE_DIALOG);
      } catch (e) {
        store.commit(Mutation.PUSH_ERROR, e);
      } finally {
        store.commit(Mutation.RELEASE_BUSSY_STATE);
      }
    };

    const cancel = () => {
      store.commit(Mutation.CLOSE_DIALOG);
    };

    const appSetting = computed(() => {
      return {
        ...store.state.appSetting,
        returnCode: returnCodeToName[store.state.appSetting.returnCode],
      };
    });

    const pieceImageTypes = [
      {
        name: "一文字駒",
        value: PieceImageType.HITOMOJI,
      },
      {
        name: "一文字駒（ゴシック体）",
        value: PieceImageType.HITOMOJI_GOTHIC,
      },
    ];

    const boardImageTypes = [
      {
        name: "木目（明るい）",
        value: BoardImageType.LIGHT,
      },
      {
        name: "木目（暖かい）",
        value: BoardImageType.WARM,
      },
      {
        name: "塩化ビニル",
        value: BoardImageType.RESIN,
      },
    ];

    return {
      dialog,
      pieceImage,
      boardImage,
      pieceVolume,
      clockVolume,
      clockPitch,
      clockSoundTarget,
      returnCode,
      appSetting,
      pieceImageTypes,
      boardImageTypes,
      saveAndClose,
      cancel,
    };
  },
});
